export function isInputTruthyValue(value: string | boolean): boolean {
  if ((value as string) === '') {
    return true;
  }
  return value as boolean;
}
